import axios from 'axios';

// Keeps the admin signed in. When the server answers 401 "TOKEN_EXPIRED", the panel quietly exchanges the old token for a new one
// (POST /auth/refresh) and repeats the failed request, so no "token expired" or "unauthorised" message is shown.
// Only a session idle for longer than the server's grace period (30 days) goes back to the login page.
const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

let refreshing = null; // several requests can fail together; they all wait for one refresh

const refreshToken = () => {
    if (!refreshing) {
        refreshing = axios
            .post(`${BASE}/auth/refresh`, null, { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } })
            .then(res => {
                localStorage.setItem('adminToken', res.data.token);
                return res.data.token;
            })
            .finally(() => { refreshing = null; });
    }
    return refreshing;
};

export const installTokenRefresh = (instance) => {
    instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const { response, config } = error;
            const expired = response && response.status === 401 && response.data && response.data.code === 'TOKEN_EXPIRED';
            if (!expired || !config || config.__retried || !localStorage.getItem('adminToken')) throw error;
            try {
                const token = await refreshToken();
                config.__retried = true;
                config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
                return await instance.request(config);
            } catch (refreshError) {
                // the repeated request may fail for another reason; only a failed refresh sends the admin back to the login page
                if (refreshError && refreshError.config && refreshError.config.__retried) throw refreshError;
                localStorage.removeItem('adminToken');
                if (window.location.pathname !== '/login') window.location.assign('/login');
                throw error;
            }
        }
    );
};
